export const EVALUATION_STATES = {
  NOT_FOUND: "NOT_FOUND",
  READY: "READY",
  IN_PROGRESS: "IN_PROGRESS",
  SUBMITTED: "SUBMITTED",
  COMPLETED: "COMPLETED",
};

export function normalizeEvaluationStatus(rawStatus) {
  const completed = rawStatus?.completed;
  const submitted = rawStatus?.submitted;
  const started = rawStatus?.started;

  let state = rawStatus?.state || null;
  if (!state) {
    if (completed === null || completed === undefined) {
      state = EVALUATION_STATES.NOT_FOUND;
    } else if (completed === true) {
      state = EVALUATION_STATES.COMPLETED;
    } else if (submitted === true) {
      state = EVALUATION_STATES.SUBMITTED;
    } else if (started === true) {
      state = EVALUATION_STATES.IN_PROGRESS;
    } else {
      state = EVALUATION_STATES.READY;
    }
  }

  const isCompleted = state === EVALUATION_STATES.COMPLETED;
  const isSubmitted = state === EVALUATION_STATES.SUBMITTED;
  const isMissing = state === EVALUATION_STATES.NOT_FOUND;
  const canResume =
    state === EVALUATION_STATES.READY || state === EVALUATION_STATES.IN_PROGRESS;

  return {
    completed: isCompleted,
    submitted: isSubmitted || isCompleted,
    started:
      Boolean(started) ||
      state === EVALUATION_STATES.IN_PROGRESS ||
      isSubmitted ||
      isCompleted,
    state,
    isCompleted,
    isSubmitted,
    isMissing,
    isBlocked: isSubmitted || isCompleted,
    canResume,
  };
}
